import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { FixingMappingState } from "../../../types";
import { axiosObj } from "../../../../config/apiClients";
import { FixingMapping } from "../../../../utils/types";

const initialState: FixingMappingState = {
  isLoading: false,
  fixingStocks: [],
  fixingMappings: [],
  pagination: {
    currentPage: 1,
    totalPages: 1,
    hasNextPage: false
  }
};

export const getFixingStocks = createAsyncThunk(
  "/neo/v2/fixingMapping/getFixingStocks",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosObj.get("neo/v2/fixingMapping/getFixingStocks");
      return response.data;
    } catch (error) {
      return rejectWithValue(error || { message: 'Failed to Fetch Fixing Stocks' });
    }
  }
);

export const createFixingMapping = createAsyncThunk(
  "/neo/v2/fixingMapping/getAllFixingMapping",
  async (FixingMapping: FixingMapping, { rejectWithValue }) => {
    try {
      const response = await axiosObj.post("neo/v2/fixingMapping/create", FixingMapping);
      return response.data;
    } catch (error) {
      return rejectWithValue(error || { message: 'Failed to create Fixing Mapping' });
    }
  }
);

export const updateFixingMapping = createAsyncThunk(
  "/neo/v2/fixingMapping/update",
  async (fixingMapping: FixingMapping, { rejectWithValue }) => {
    try {
      const response = await axiosObj.patch("neo/v2/fixingMapping/update", { ...fixingMapping, id: fixingMapping._id });
      return response.data;
    } catch (error) {
      return rejectWithValue(error || { message: 'Failed to update Fixing Mapping' });
    }
  }
);

export const deleteFixingMapping = createAsyncThunk(
  "/neo/v2/fixingMapping/delete",
  async (fixingMappingId: string, { rejectWithValue }) => {
    try {
      const response = await axiosObj.delete("neo/v2/fixingMapping/delete", { data: { fixingMappingId } });
      return response.data;
    } catch (error) {
      return rejectWithValue(error || { message: 'Failed to delete Fixing Mapping' });
    }
  }
);

export const getAllFixingMapping = createAsyncThunk(
  "/neo/v2/fixingMapping/getAll",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosObj.get("neo/v2/fixingMapping/getAll");
      return response.data;
    } catch (error) {
      return rejectWithValue(error || { message: 'Failed to Fetch fixing Mapping' });
    }
  }
);

const fixingMappingSlice = createSlice({
  name: "fixingMapping",
  initialState,
  reducers: {
    removeFixingMapping: (state, action) => {
      const id = action.payload;
      state.fixingMappings = state.fixingMappings.filter((item) => item._id !== id);
    },
    resetFixingMappingState: (state) => {
      state.isLoading = false;
      state.fixingMappings = [];
      state.pagination = {
        currentPage: 1,
        totalPages: 1,
        hasNextPage: false
      };
    }
  },
  extraReducers(builder) {
    builder
      .addCase(getFixingStocks.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getFixingStocks.fulfilled, (state, action) => {
        state.isLoading = false;
        state.fixingStocks = action.payload.payload.kAllFixingStocks;
      })
      .addCase(getFixingStocks.rejected, (state) => {
        state.isLoading = false;
        state.fixingStocks = [];
      })
      .addCase(getAllFixingMapping.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAllFixingMapping.fulfilled, (state, action) => {
        state.isLoading = false;
        state.fixingMappings = action.payload.payload.allFixingMappings;
      })
      .addCase(getAllFixingMapping.rejected, (state) => {
        state.isLoading = false;
        state.fixingMappings = [];
      });
  }
})

export const { resetFixingMappingState, removeFixingMapping } = fixingMappingSlice.actions;

export default fixingMappingSlice.reducer;